import { useEffect, useRef } from 'react';
import { AppPavilionDataMap } from '../../utils/getStandsDataMap';

const SCROLL_DURATION = 400;

const easeInOut = (t: number) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

export const useMapScrollToRoom = (
    mapPlanRef: React.RefObject<HTMLDivElement>,
    activeRoom: AppPavilionDataMap | null,
) => {
    const rafRef = useRef<number | null>(null);

    useEffect(() => {
        if (!activeRoom?.slug || !mapPlanRef.current) return;

        const container = mapPlanRef.current;
        const roomEl = container.querySelector<SVGGElement>(`#room-${activeRoom.slug}`);
        if (!roomEl) return;

        const roomRect = roomEl.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        // Центр комнаты в координатах скроллируемого контента
        const roomCenterX = roomRect.left - containerRect.left + container.scrollLeft + roomRect.width / 2;
        const roomCenterY = roomRect.top - containerRect.top + container.scrollTop + roomRect.height / 2;

        const targetScrollLeft = roomCenterX - container.clientWidth / 2;
        const targetScrollTop = roomCenterY - container.clientHeight / 2;

        const startScrollLeft = container.scrollLeft;
        const startScrollTop = container.scrollTop;

        if (rafRef.current !== null) {
            cancelAnimationFrame(rafRef.current);
        }

        const startTime = performance.now();

        const animate = (now: number) => {
            const progress = Math.min((now - startTime) / SCROLL_DURATION, 1);
            const eased = easeInOut(progress);

            container.scrollLeft = startScrollLeft + (targetScrollLeft - startScrollLeft) * eased;
            container.scrollTop = startScrollTop + (targetScrollTop - startScrollTop) * eased;

            if (progress < 1) {
                rafRef.current = requestAnimationFrame(animate);
            } else {
                rafRef.current = null;
            }
        };

        rafRef.current = requestAnimationFrame(animate);

        return () => {
            if (rafRef.current !== null) {
                cancelAnimationFrame(rafRef.current);
            }
        };
    }, [activeRoom, mapPlanRef]);
};
